import React, {useState, useEffect, useContext, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import {toast, ToastContainer} from "react-toastify";

import GoBack from "../../../components/goBack";
import OrgContext from "../../../organisation/OrgContext";
import jwtInterceoptor from "../../../components/shared/jwtInterceptor";


const AddCs = (props) => {
    const navigate = useNavigate();
    const [t, i18n] = useTranslation();
    const {organisation, changeOrg} = useContext(OrgContext);

    const [accountCode, setAccountCode] = useState('');
    const [accountDescription, setAccountDescription] = useState('');
    const [accountName, setAccountName] = useState('');
    const [csAccounts, setCsAccounts] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getCsAccounts();
    }, []);

    /**
     *
     * @return {Promise<void>}
     */
    const getCsAccounts = async () => {
        await jwtInterceoptor.get('/data/user/cs/accounts/'+organisation.id, ).then(res => {
            setCsAccounts(res.data.data);
            setLoaded(true);
        }).catch((error) => {
            console.log(error)
        });
    }
    /**
     *
     * @param event
     * @return {Promise<void>}
     */
    const save = async (event) => {
        event.preventDefault();
        //check all req
        if (accountName !== "" && accountCode !== "" && accountDescription !== "") {
            /**
             *
             * @type {boolean}
             */
            let csCodeAlreadyExist=false;

            for(let i=0;i<csAccounts.length;i++){
                if( csAccounts[i]['code'] === "5161" + accountCode ){
                    csCodeAlreadyExist=true;
                    break;
                }
            }

            if(csCodeAlreadyExist){
                toast.error(t('Le code comptable choisi existe déja !'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }else{
                const preparedObject = {
                    name: accountName,
                    description: accountDescription,
                    code: "5161" + accountCode,
                    organization_id: organisation.id,
                    is_cs_accounts: 1,
                    type: "Comptes de trésorerie (classe 5)"
                };

                await jwtInterceoptor.post('/data/user/accounts', preparedObject).then(res => {
                    Swal.fire(
                        t('Compte a été ajouter avec succès'),
                        t(''),
                        'success'
                    );
                    navigate('/cs')
                }).catch((error) => {
                    console.log(error)
                });
            }


        } else {
            toast.error(t('Vérifier les champs obligatoire !'), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }

    }

    return (
        <>
            <div className="main-container container-fluid">
                {props.from==='main' ? <GoBack route={'/cs/list'}/> : null}
                <div className="page-header">
                    <h1 className="page-title breadcumpsHeader">Compte comptable de la caisse</h1>
                    <div>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="javascript:void(0)"
                                                               onClick={() => navigate('/cs/list')}>Liste des comptes comptable de la caisse</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Ajouter un compte comptable de la caisse</li>
                        </ol>
                    </div>
                </div>
            </div>

            <div className="col-md-12" style={{display: loaded ? 'none' : 'block'}}>
                <center>
                    <div class="spinner-border text-primary me-2" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </center>
            </div>

            <div className="row" style={{display: loaded ? 'block' : 'none'}}>
                <ToastContainer/>

                <div className="col-xl-12">

                    <div className="card">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail1" className="">Nom du compte*</label>
                                        <input type="text" placeholder="Compte de la caisse no01" className={`form-control`}
                                               onChange={(e) => setAccountName(e.target.value)}
                                               value={accountName}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="accountsCode" className="">Code du compte*</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text accountCodeSufix">5161</span>
                                        <input type="text" className={`form-control`} placeholder={'CS01'}
                                               aria-label="Amount (to the nearest dollar)" id="accountsCode"
                                               onChange={(e) => setAccountCode(e.target.value)} value={accountCode}/>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Description du compte*</label>
                                <input type="text" placeholder="ce compte dédier pour les transaction ..." className={`form-control `}
                                       onChange={(e) => setAccountDescription(e.target.value)}
                                       value={accountDescription}/>
                            </div>

                            <br/>
                            <div class="card-footer">
                                <div class="row">
                                    <div class="col-md-12"><button
                                        className="btn-lg btn-primary saveBtn"
                                        onClick={save}>{'Enregistrer'}</button>
                                        <a onClick={() => {
                                            navigate('/bq')
                                        }} className="btn btn-default float-end">Annuler</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCs;